import React from "react";
import RadioBlock from "../radio-block/RadioBlock";
import PropTypes from 'prop-types';
import {WebPayIcon} from "presentation/common/components/style-guide/icons";

export const WebPay = (props) => {
  const {paymentType, ...other} = props;

  return (
    <RadioBlock
      {...other}
      checked={paymentType === "WebPay"}
      className="my-2"
      name="online-payment"
      id="radio-webpay"
      value="WebPay"
      label={<span>Pago en línea con tu tarjeta de débito o crédito en WebPay</span>}
      end={<div className="flex-center"><WebPayIcon/></div>}
    />
  );
};

WebPay.propTypes = {
  paymentType: PropTypes.string
}

WebPay.defaultProps = {
  paymentType: ""
}

export default WebPay;
